import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/apps/webapp/src/app/global-error.tsx");
